import React, {createRef} from 'react';
import Message from './Message.jsx';
import ChatEventCodes from '../utils/ChatEventCodes.js';

/**
 * Class to display the login message template.
 */
export default class LoginMessage extends Message {
    constructor(props) {
        super(props);

        this.state = {
            userInteracted: false
        }
        this.messageRef = createRef();
    }

    componentDidMount() {
        super.componentDidMount();
        this.setEventListeners();
    }

    /**
     * Set the event listener on the message if the user clicks the login link.
     */
    setEventListeners() {
        if (this.props.message.isChatHistory || this.state.userInteracted || !this.messageRef?.current) {
            return;
        }
        this.messageRef.current.addEventListener('click', (/** @type {MouseEvent} */ e) => {
            e.preventDefault();
            if (!e.target.classList.contains('login-link')) {
                return;
            }
            this.setState({userInteracted: true}, () => {
                document.dispatchEvent(new MessageEvent(ChatEventCodes.LoginFlowStarted, {data: this.props.payload.loginUrl}));
            });
        });
    }

    render() {
        if (this.props.message.isChatHistory || this.state.userInteracted) {
            return <div className={this.generateSenderClassName('login')} />
        }

        return  <div className={this.generateSenderClassName('login')} ref={this.messageRef}>
                    {this.generateSenderMessage()}
                    <div className='login__text message-text'>
                        <a href={this.props.payload.loginUrl} className='login-link' title='Proceed to the login page.'>{this.props.payload.text}</a>
                    </div>
                </div>
    }
}